const languages = [
    {
        name: 'JavaScript',
        imgUrl: '/technologies/js.png'
    },
    {
        name: 'TypeScript',
        imgUrl: '/technologies/typescript.svg'
    },
    {
        name: 'PHP',
        imgUrl: '/technologies/php.svg'
    },
    {
        name: 'Ruby',
        imgUrl: '/technologies/ruby.svg'
    },
    {
        name: 'Go',
        imgUrl: '/technologies/go.svg'
    }
]

export default languages